import React from "react";
import { useTheme } from "styled-components";

import Avatar from "@mui/material/Avatar";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { Row } from "react-bootstrap";

import { imageUrl } from "../../config";
import { ConfidenceCast } from "../../models/ConfidencePool";
import { League } from "../../models/Leagues";

import TableTeam from "../atoms/TableTeam";
import CastTeam from "./CastTeam";
import WeeklyListAnalytics from "./WeeklyListAnalytics";

interface ConfidenceListItemProps {
    player: ConfidenceCast;
    points: number;
    league: League;
}

const ConfidenceListItem: React.FC<ConfidenceListItemProps> = ({
    player,
    points,
    league,
}) => {
    const theme = useTheme();

    return (
        <TableTeam style={{ cursor: "move" }}>
            <tbody>
                <tr>
                    <td className="pl-4">
                        <Row className="align-items-center">
                            <Avatar
                                style={{ height: 60, width: 60 }}
                                src={`${imageUrl}${player.pic}`}
                            />
                            <div className="pl-2">
                                <span
                                    style={{ color: theme.textColor }}
                                >{`${player.name}`}</span>
                                <CastTeam
                                    left
                                    size={10}
                                    team={
                                        player.cast
                                            ? player.cast.team
                                            : player.team
                                    }
                                    partner={
                                        player.cast
                                            ? player.cast.partner
                                            : player.partner
                                    }
                                />
                            </div>
                        </Row>
                        <WeeklyListAnalytics league={league} item={player} />
                    </td>
                    <td className="text-right" style={{ width: 120 }}>
                        <Row
                            className="align-items-center"
                            style={{
                                justifyContent: "flex-end",
                                marginRight: 15,
                            }}
                        >
                            <span className="pr-3" style={{ fontSize: 20 }}>
                                {points}
                            </span>
                            <DragHandleIcon />
                        </Row>
                    </td>
                </tr>
            </tbody>
        </TableTeam>
    );
};

export default ConfidenceListItem;
